import Continue from '../images/chevron-right.svg';
import File from '../images/file.svg';
import ActionRequired from '../images/actionrequired.svg';
import NotStarted from '../images/Dot.svg'
import ClientActionRequired from '../images/ClientActionRequired.svg'
import CompleteActive from '../images/CompleteActiveIcon.svg'
import CompleteInactive from '../images/CompleteInactiveIcon.svg'
import DocumentsStepComplete from '../images/DocumentsStepCompleteIcon.svg'
import ManualPreparePaymentComplete from '../images/ManualPreparePaymentCompleteIcon.svg'
import SurveySectionIcon from '../images/NPSIcon.svg'

export const getIcon = (svg) => {
    switch (svg) {
        case 'file':
            return File;
        case 'chevron-right':
            return Continue;
        case 'action-required':
            return ActionRequired;
        case 'not-started':
            return NotStarted;
        case 'client-action-required':
            return ClientActionRequired;
        case 'complete-active':
            return CompleteActive;
        case 'complete-inactive':
            return CompleteInactive;
        case 'documents-step-complete':
            return DocumentsStepComplete;
        case 'manual-prepare-payment-complete':
            return ManualPreparePaymentComplete;
        case 'survey-section-icon':
            return SurveySectionIcon;
        default:
            return null;
    }
};